import React from "react";
import "../styles/parks-australia.scss";
import Layout from './layout';

export default function PageLayout({ children }) {
  return <Layout>{children}</Layout>;
}
